
const HazmatTable = ({ hazmat }) => {
  if (!hazmat || !hazmat.TsaHazMatThreatDetermination) return null;

  return (
    <>
      <th>Hazmat Determination</th>
      <table className="table table-striped table-bordered">
        <thead>
          <tr>
            <th>TSA Hazmat Determination</th>
            <th>Hazmat Expiration Date</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{hazmat.TsaHazMatThreatDetermination}</td>
            <td>{hazmat.ExpirationDate}</td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default HazmatTable;
